import { render, staticRenderFns } from "./kyc-setting-inner.vue?vue&type=template&id=10996fa6&"
import script from "./kyc-setting-inner.vue?vue&type=script&lang=js&"
export * from "./kyc-setting-inner.vue?vue&type=script&lang=js&"
import style0 from "./kyc-setting-inner.vue?vue&type=style&index=0&id=10996fa6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports